<template>
  <div id="login">
    <div class="h-100 d-flex flex-justify-center flex-align-center">
      <div class="card shadow-1 m-5" style="border-radius: 5%">
        <button class="button bg-transparent p-5" @click="$router.back();">
          <span class="mif-arrow-left mif-3x"></span>
        </button>
        <h1 class="mb-0 mt-10 text-center text-medium"><span class="fg-blue">VCS</span>agentes</h1>
        <div class="px-10" id="vm_login">
          <div class="text-center text-light">Entrega de paquetes y servicios.</div>
          <form data-role="validator" class="mt-10" action="javascript:" data-clear-invalid="2000" autocomplete="off"
                data-interactive-check="true" data-on-submit="login.__vue__.login()">
            <div class="form-group">
              <input type="email" data-validate="required email" placeholder="Ingresa dirección de correo"
                     data-prepend="<span class='mif-envelop fg-green'>" data-role="input"
                     data-clear-button="false" v-model="form.email">
              <span class="invalid_feedback">
                Ingrese una dirección de correo
              </span>
            </div>
            <div class="form-group">
              <input type="password" data-validate="required" data-prepend="<span class='mif-key fg-blue'>"
                     placeholder="Contraseña" data-role="input"
                     data-clear-button="false" v-model="form.password">
              <span class="invalid_feedback">Ingrese la contraseña</span>
            </div>
            <div class="form-actions text-center my-10">
              <button class="image-button rounded primary">
                <span class="caption">Iniciar sesión</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: function() {
    return {
      form:{
        email: '',
        password: null,
      },
    };
  },
  mounted: function() {
    $('html, body').animate({scrollTop: 0}, 'slow');
  },
  methods: {
    login:async function(){
      try {
        await this.$store.dispatch('login_agentes',this.form)
        return this.$router.replace({ path:"/agentes"})
      }
      catch (error) {
        const error_json = JSON.parse(error.request.response)
        console.log(error_json)
        console.log(error.request.response)

        if(error_json.email){
          Metro.notify.create(error_json.error,null, {
            cls: "alert"
          });
          this.form = {}
        }
        if(error_json.password){
          this.form.password = ""
          Metro.notify.create(error_json.error,null, {
            cls: "alert"
          });
        }
      }
    },
  }
};
</script>
<style>
.bubbels{
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 0;
  overflow: hidden;
  top: 0;
  left: 0;
}
.bubble{
  position: absolute;
  bottom: -100px;
  background: #f1f1f1;
  border-radius: 50%;
  opacity: 0.5;
  animation: flying 10s infinite ease-in;
}
.bubble:nth-child(1){
  width: 40px;
  height: 40px;
  left: 10%;
  animation-duration: 8s;
}
.bubble:nth-child(2){
  width: 20px;
  height: 20px;
  left: 20%;
  animation-duration: 5s;
  animation-delay: 1s;
}
.bubble:nth-child(3){
  width: 50px;
  height: 50px;
  left: 35%;
  animation-duration: 10s;
  animation-delay: 2s;
}

.bubble:nth-child(4){
  width: 80px;
  height: 80px;
  left: 50%;
  animation-duration: 7s;
  animation-delay: 0s;
}

.bubble:nth-child(5){
  width: 35px;
  height: 35px;
  left: 55%;
  animation-duration: 6s;
  animation-delay: 1s;
}
.bubble:nth-child(6){
  width: 45px;
  height: 45px;
  left: 65%;
  animation-duration: 8s;
  animation-delay: 3s;
}
.bubble:nth-child(7){
  width: 25px;
  height: 25px;
  left: 75%;
  animation-duration: 7s;
  animation-delay: 2s;
}
.bubble:nth-child(8){
  width: 80px;
  height: 80px;
  left: 80%;
  animation-duration: 6s;
  animation-delay: 1s;
}

.bubble:nth-child(9){
  width: 15px;
  height: 15px;
  left: 70%;
  animation-duration: 9s;
  animation-delay: 0s;
}

.bubble:nth-child(10){
  width: 50px;
  height: 50px;
  left: 85%;
  animation-duration: 5s;
  animation-delay: 3s;
}

@keyframes flying {
  0%{
    bottom: -100px;
    transform: translateX(0);
  }
  50%{
    transform: translateX(100px);
  }
  100%{
    bottom: 1080px;
    transform: translateX(-200px);
  }
}
</style>
